import '../assets/referencePickerModal-A0PlFUEI.css';
import { isWidgetRegistered as Pt, destroyWidget as Ct, renderWidget as Et, isCustomPickerElementRegistered as z, destroyCustomPickerElement as kt, renderCustomPickerElement as St, getCustomPickerElementSize as xt } from "../Functions/registerReference.mjs";
import { n as N } from "./_plugin-vue2_normalizer-u6G_3nkj.mjs";
import { r as F, O as $t, a as k, P as Nt, Q as Ke, R as Lt, u as Ot, S as Tt, G as At, T as It } from "./_l10n-FmsZpnE4.mjs";
import ge from "@nextcloud/axios";
import { loadState as Ze } from "@nextcloud/initial-state";
import { getBaseUrl as Vt, imagePath as jt, generateOcsUrl as Y } from "@nextcloud/router";
import ye from "../Components/NcEmptyContent.mjs";
import { N as Je } from "./index-2phCrsSH.mjs";
import { N as Xe } from "./NcSelect-b2H-YQsK.mjs";
import { visit as Bt, SKIP as qt } from "unist-util-visit";
import { u as fe } from "unist-builder";
import { useResizeObserver as Mt } from "@vueuse/core";
import Ut from "../Components/NcLoadingIcon.mjs";
import { N as Dt } from "./NcTextField-NnW31cA4.mjs";
import { D as zt } from "./DotsHorizontal-IbmXTXRA.mjs";
import Ft from "../Components/NcButton.mjs";
import Wt from "../Components/NcModal.mjs";
import { emit as Ht } from "@nextcloud/event-bus";
import { A as Gt } from "./ArrowLeft-uW5eNVkY.mjs";
import { C as Qt } from "./Close-QtH6_3PP.mjs";
import Kt from "vue";
/*!
  * vue-router v3.6.5
  * (c) 2022 Evan You
  * @license MIT
  */
function I(t, e) {
  if (!t)
    throw new Error("[vue-router] " + e);
}
function P(t, e) {
  t || typeof console < "u" && console.warn("[vue-router] " + e);
}
function S(t, e) {
  for (var r in e)
    t[r] = e[r];
  return t;
}
var Zt = /[!'()*]/g, Jt = function(t) {
  return "%" + t.charCodeAt(0).toString(16);
}, Xt = /%2C/g, j = function(t) {
  return encodeURIComponent(t).replace(Zt, Jt).replace(Xt, ",");
};
function he(t) {
  try {
    return decodeURIComponent(t);
  } catch {
    process.env.NODE_ENV !== "production" && P(!1, 'Error decoding "' + t + '". Leaving it intact.');
  }
  return t;
}
function Yt(t, e, r) {
  e === void 0 && (e = {});
  var n = r || er, i;
  try {
    i = n(t || "");
  } catch (a) {
    process.env.NODE_ENV !== "production" && P(!1, a.message), i = {};
  }
  for (var s in e) {
    var o = e[s];
    i[s] = Array.isArray(o) ? o.map(xe) : xe(o);
  }
  return i;
}
var xe = function(t) {
  return t == null || typeof t == "object" ? t : String(t);
};
function er(t) {
  var e = {};
  return t = t.trim().replace(/^(\?|#|&)/, ""), t && t.split("&").forEach(function(r) {
    var n = r.replace(/\+/g, " ").split("="), i = he(n.shift()), s = n.length > 0 ? he(n.join("=")) : null;
    e[i] === void 0 ? e[i] = s : Array.isArray(e[i]) ? e[i].push(s) : e[i] = [e[i], s];
  }), e;
}
function tr(t) {
  var e = t ? Object.keys(t).map(function(r) {
    var n = t[r];
    if (n === void 0)
      return "";
    if (n === null)
      return j(r);
    if (Array.isArray(n)) {
      var i = [];
      return n.forEach(function(s) {
        s !== void 0 && (s === null ? i.push(j(r)) : i.push(j(r) + "=" + j(s)));
      }), i.join("&");
    }
    return j(r) + "=" + j(n);
  }).filter(function(r) {
    return r.length > 0;
  }).join("&") : null;
  return e ? "?" + e : "";
}
var ee = /\/?$/;
function te(t, e, r, n) {
  var i = n && n.options.stringifyQuery, s = e.query || {};
  try {
    s = pe(s);
  } catch {
  }
  var o = {
    name: e.name || t && t.name,
    meta: t && t.meta || {},
    path: e.path || "/",
    hash: e.hash || "",
    query: s,
    params: e.params || {},
    fullPath: $e(e, i),
    matched: t ? rr(t) : []
  };
  return r && (o.redirectedFrom = $e(r, i)), Object.freeze(o);
}
function pe(t) {
  if (Array.isArray(t))
    return t.map(pe);
  if (t && typeof t == "object") {
    var e = {};
    for (var r in t)
      e[r] = pe(t[r]);
    return e;
  } else
    return t;
}
var A = te(null, {
  path: "/"
});
function rr(t) {
  for (var e = []; t; )
    e.unshift(t), t = t.parent;
  return e;
}
function $e(t, e) {
  var r = t.path, n = t.query;
  n === void 0 && (n = {});
  var i = t.hash;
  i === void 0 && (i = "");
  var s = e || tr;
  return (r || "/") + s(n) + i;
}
function Ye(t, e, r) {
  return e === A ? t === e : e ? t.path && e.path ? t.path.replace(ee, "") === e.path.replace(ee, "") && (r || t.hash === e.hash && Q(t.query, e.query)) : t.name && e.name ? t.name === e.name && (r || t.hash === e.hash && Q(t.query, e.query) && Q(t.params, e.params)) : !1 : !1;
}
function Q(t, e) {
  if (t === void 0 && (t = {}), e === void 0 && (e = {}), !t || !e)
    return t === e;
  var r = Object.keys(t).sort(), n = Object.keys(e).sort();
  return r.length !== n.length ? !1 : r.every(function(i, s) {
    var o = t[i], a = n[s];
    if (a !== i)
      return !1;
    var c = e[i];
    return o == null || c == null ? o === c : typeof o == "object" && typeof c == "object" ? Q(o, c) : String(o) === String(c);
  });
}
function nr(t, e) {
  return t.path.replace(ee, "/").indexOf(
    e.path.replace(ee, "/")
  ) === 0 && (!e.hash || t.hash === e.hash) && ir(t.query, e.query);
}
function ir(t, e) {
  for (var r in e)
    if (!(r in t))
      return !1;
  return !0;
}
function et(t) {
  for (var e = 0; e < t.matched.length; e++) {
    var r = t.matched[e];
    for (var n in r.instances) {
      var i = r.instances[n], s = r.enteredCbs[n];
      if (!(!i || !s)) {
        delete r.enteredCbs[n];
        for (var o = 0; o < s.length; o++)
          i._isBeingDestroyed || s[o](i);
      }
    }
  }
}
var sr = {
  name: "RouterView",
  functional: !0,
  props: {
    name: {
      type: String,
      default: "default"
    }
  },
  render: function(e, r) {
    var n = r.props, i = r.children, s = r.parent, o = r.data;
    o.routerView = !0;
    for (var a = s.$createElement, c = n.name, u = s.$route, d = s._routerViewCache || (s._routerViewCache = {}), m = 0, h = !1; s && s._routerRoot !== s; ) {
      var v = s.$vnode ? s.$vnode.data : {};
      v.routerView && m++, v.keepAlive && s._directInactive && s._inactive && (h = !0), s = s.$parent;
    }
    if (o.routerViewDepth = m, h) {
      var p = d[c], l = p && p.component;
      return l ? (p.configProps && Ne(l, o, p.route, p.configProps), a(l, o, i)) : a();
    }
    var f = u.matched[m], g = f && f.components[c];
    if (!f || !g)
      return d[c] = null, a();
    d[c] = { component: g }, o.registerRouteInstance = function(y, w) {
      var R = f.instances[c];
      (w && R !== y || !w && R === y) && (f.instances[c] = w);
    }, (o.hook || (o.hook = {})).prepatch = function(y, w) {
      f.instances[c] = w.componentInstance;
    }, o.hook.init = function(y) {
      y.data.keepAlive && y.componentInstance && y.componentInstance !== f.instances[c] && (f.instances[c] = y.componentInstance), et(u);
    };
    var _ = f.props && f.props[c];
    return _ && (S(d[c], {
      route: u,
      configProps: _
    }), Ne(g, o, u, _)), a(g, o, i);
  }
};
function Ne(t, e, r, n) {
  var i = e.props = or(r, n);
  if (i) {
    i = e.props = S({}, i);
    var s = e.attrs = e.attrs || {};
    for (var o in i)
      (!t.props || !(o in t.props)) && (s[o] = i[o], delete i[o]);
  }
}
function or(t, e) {
  switch (typeof e) {
    case "undefined":
      return;
    case "object":
      return e;
    case "function":
      return e(t);
    case "boolean":
      return e ? t.params : void 0;
    default:
      process.env.NODE_ENV !== "production" && P(
        !1,
        'props in "' + t.path + '" is a ' + typeof e + ", expecting an object, function or boolean."
      );
  }
}
function tt(t, e, r) {
  var n = t.charAt(0);
  if (n === "/")
    return t;
  if (n === "?" || n === "#")
    return e + t;
  var i = e.split("/");
  (!r || !i[i.length - 1]) && i.pop();
  for (var s = t.replace(/^\//, "").split("/"), o = 0; o < s.length; o++) {
    var a = s[o];
    a === ".." ? i.pop() : a !== "." && i.push(a);
  }
  return i[0] !== "" && i.unshift(""), i.join("/");
}
function ar(t) {
  var e = "", r = "", n = t.indexOf("#");
  n >= 0 && (e = t.slice(n), t = t.slice(0, n));
  var i = t.indexOf("?");
  return i >= 0 && (r = t.slice(i + 1), t = t.slice(0, i)), {
    path: t,
    query: r,
    hash: e
  };
}
function L(t) {
  return t.replace(/\/(?:\s*\/)+/g, "/");
}
var re = Array.isArray || function(t) {
  return Object.prototype.toString.call(t) == "[object Array]";
}, q = it, cr = _e, ur = pr, lr = rt, fr = nt, hr = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  "(\\\\.)",
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
function _e(t, e) {
  for (var r = [], n = 0, i = 0, s = "", o = e && e.delimiter || "/", a; (a = hr.exec(t)) != null; ) {
    var c = a[0], u = a[1], d = a.index;
    if (s += t.slice(i, d), i = d + c.length, u) {
      s += u[1];
      continue;
    }
    var m = t[i], h = a[2], v = a[3], p = a[4], l = a[5], f = a[6], g = a[7];
    s && (r.push(s), s = "");
    var _ = h != null && m != null && m !== h, y = f === "+" || f === "*", w = f === "?" || f === "*", R = a[2] || o, C = p || l;
    r.push({
      name: v || n++,
      prefix: h || "",
      delimiter: R,
      optional: w,
      repeat: y,
      partial: _,
      asterisk: !!g,
      pattern: C ? mr(C) : g ? ".*" : "[^" + K(R) + "]+?"
    });
  }
  return i < t.length && (s += t.substr(i)), s && r.push(s), r;
}
function pr(t, e) {
  return rt(_e(t, e), e);
}
function dr(t) {
  return encodeURI(t).replace(/[\/?#]/g, function(e) {
    return "%" + e.charCodeAt(0).toString(16).toUpperCase();
  });
}
function vr(t) {
  return encodeURI(t).replace(/[?#]/g, function(e) {
    return "%" + e.charCodeAt(0).toString(16).toUpperCase();
  });
}
function rt(t, e) {
  for (var r = new Array(t.length), n = 0; n < t.length; n++)
    typeof t[n] == "object" && (r[n] = new RegExp("^(?:" + t[n].pattern + ")$", we(e)));
  return function(i, s) {
    for (var o = "", a = i || {}, c = s || {}, u = c.pretty ? dr : encodeURIComponent, d = 0; d < t.length; d++) {
      var m = t[d];
      if (typeof m == "string") {
        o += m;
        continue;
      }
      var h = a[m.name], v;
      if (h == null)
        if (m.optional) {
          m.partial && (o += m.prefix);
          continue;
        } else
          throw new TypeError('Expected "' + m.name + '" to be defined');
      if (re(h)) {
        if (!m.repeat)
          throw new TypeError('Expected "' + m.name + '" to not repeat, but received `' + JSON.stringify(h) + "`");
        if (h.length === 0) {
          if (m.optional)
            continue;
          throw new TypeError('Expected "' + m.name + '" to not be empty');
        }
        for (var p = 0; p < h.length; p++) {
          if (v = u(h[p]), !r[d].test(v))
            throw new TypeError('Expected all "' + m.name + '" to match "' + m.pattern + '", but received `' + JSON.stringify(v) + "`");
          o += (p === 0 ? m.prefix : m.delimiter) + v;
        }
        continue;
      }
      if (v = m.asterisk ? vr(h) : u(h), !r[d].test(v))
        throw new TypeError('Expected "' + m.name + '" to match "' + m.pattern + '", but received "' + v + '"');
      o += m.prefix + v;
    }
    return o;
  };
}
function K(t) {
  return t.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
function mr(t) {
  return t.replace(/([=!:$\/()])/g, "\\$1");
}
function be(t, e) {
  return t.keys = e, t;
}
function we(t) {
  return t && t.sensitive ? "" : "i";
}
function gr(t, e) {
  var r = t.source.match(/\((?!\?)/g);
  if (r)
    for (var n = 0; n < r.length; n++)
      e.push({
        name: n,
        prefix: null,
        delimiter: null,
        optional: !1,
        repeat: !1,
        partial: !1,
        asterisk: !1,
        pattern: null
      });
  return be(t, e);
}
function yr(t, e, r) {
  for (var n = [], i = 0; i < t.length; i++)
    n.push(it(t[i], e, r).source);
  var s = new RegExp("(?:" + n.join("|") + ")", we(r));
  return be(s, e);
}
function _r(t, e, r) {
  return nt(_e(t, r), e, r);
}
function nt(t, e, r) {
  re(e) || (r = /** @type {!Object} */
  e || r, e = []), r = r || {};
  for (var n = r.strict, i = r.end !== !1, s = "", o = 0; o < t.length; o++) {
    var a = t[o];
    if (typeof a == "string")
      s += K(a);
    else {
      var c = K(a.prefix), u = "(?:" + a.pattern + ")";
      e.push(a), a.repeat && (u += "(?:" + c + u + ")*"), a.optional ? a.partial ? u = c + "(" + u + ")?" : u = "(?:" + c + "(" + u + "))?" : u = c + "(" + u + ")", s += u;
    }
  }
  var d = K(r.delimiter || "/"), m = s.slice(-d.length) === d;
  return n || (s = (m ? s.slice(0, -d.length) : s) + "(?:" + d + "(?=$))?"), i ? s += "$" : s += n && m ? "" : "(?=" + d + "|$)", be(new RegExp("^" + s, we(r)), e);
}
function it(t, e, r) {
  return re(e) || (r = /** @type {!Object} */
  e || r, e = []), r = r || {}, t instanceof RegExp ? gr(
    t,
    /** @type {!Array} */
    e
  ) : re(t) ? yr(
    /** @type {!Array} */
    t,
    /** @type {!Array} */
    e,
    r
  ) : _r(
    /** @type {string} */
    t,
    /** @type {!Array} */
    e,
    r
  );
}
q.parse = cr;
q.compile = ur;
q.tokensToFunction = lr;
q.tokensToRegExp = fr;
var Le = /* @__PURE__ */ Object.create(null);
function Z(t, e, r) {
  e = e || {};
  try {
    var n = Le[t] || (Le[t] = q.compile(t));
    return typeof e.pathMatch == "string" && (e[0] = e.pathMatch), n(e, { pretty: !0 });
  } catch (i) {
    return process.env.NODE_ENV !== "production" && P(typeof e.pathMatch == "string", "missing param for " + r + ": " + i.message), "";
  } finally {
    delete e[0];
  }
}
function Re(t, e, r, n) {
  var i = typeof t == "string" ? { path: t } : t;
  if (i._normalized)
    return i;
  if (i.name) {
    i = S({}, t);
    var s = i.params;
    return s && typeof s == "object" && (i.params = S({}, s)), i;
  }
  if (!i.path && i.params && e) {
    i = S({}, i), i._normalized = !0;
    var o = S(S({}, e.params), i.params);
    if (e.name)
      i.name = e.name, i.params = o;
    else if (e.matched.length) {
      var a = e.matched[e.matched.length - 1].path;
      i.path = Z(a, o, "path " + e.path);
    } else
      process.env.NODE_ENV !== "production" && P(!1, "relative params navigation requires a current route.");
    return i;
  }
  var c = ar(i.path || ""), u = e && e.path || "/", d = c.path ? tt(c.path, u, r || i.append) : u, m = Yt(
    c.query,
    i.query,
    n && n.options.parseQuery
  ), h = i.hash || c.hash;
  return h && h.charAt(0) !== "#" && (h = "#" + h), {
    _normalized: !0,
    path: d,
    query: m,
    hash: h
  };
}
var br = [String, Object], wr = [String, Array], Oe = function() {
}, Te, Ae, Ie, st = {
  name: "RouterLink",
  props: {
    to: {
      type: br,
      required: !0
    },
    tag: {
      type: String,
      default: "a"
    },
    custom: Boolean,
    exact: Boolean,
    exactPath: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    ariaCurrentValue: {
      type: String,
      default: "page"
    },
    event: {
      type: wr,
      default: "click"
    }
  },
  render: function(e) {
    var r = this, n = this.$router, i = this.$route, s = n.resolve(
      this.to,
      i,
      this.append
    ), o = s.location, a = s.route, c = s.href, u = {}, d = n.options.linkActiveClass, m = n.options.linkExactActiveClass, h = d ?? "router-link-active", v = m ?? "router-link-exact-active", p = this.activeClass == null ? h : this.activeClass, l = this.exactActiveClass == null ? v : this.exactActiveClass, f = a.redirectedFrom ? te(null, Re(a.redirectedFrom), null, n) : a;
    u[l] = Ye(i, f, this.exactPath), u[p] = this.exact || this.exactPath ? u[l] : nr(i, f);
    var g = u[l] ? this.ariaCurrentValue : null, _ = function(le) {
      Ve(le) && (r.replace ? n.replace(o, Oe) : n.push(o, Oe));
    }, y = { click: Ve };
    Array.isArray(this.event) ? this.event.forEach(function(le) {
      y[le] = _;
    }) : y[this.event] = _;
    var w = { class: u }, R = !this.$scopedSlots.$hasNormal && this.$scopedSlots.default && this.$scopedSlots.default({
      href: c,
      route: a,
      navigate: _,
      isActive: u[p],
      isExactActive: u[l]
    });
    if (R) {
      if (process.env.NODE_ENV !== "production" && !this.custom && (!Te && P(!1, `In Vue Router 4, the v-slot API will by default wrap its content with an <a> element. Use the custom prop to remove this warning:
<router-link v-slot="{ navigate, href }" custom></router-link>
`), Te = !0), R.length === 1)
        return R[0];
      if (R.length > 1 || !R.length)
        return process.env.NODE_ENV !== "production" && P(
          !1,
          '<router-link> with to="' + this.to + `" is trying to use a scoped slot but it didn't provide exactly one child. Wrapping the content with a span element.`
        ), R.length === 0 ? e() : e("span", {}, R);
    }
    if (process.env.NODE_ENV !== "production" && ("tag" in this.$options.propsData && !Ae && (P(
      !1,
      "<router-link>'s tag prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link."
    ), Ae = !0), "event" in this.$options.propsData && !Ie && (P(
      !1,
      "<router-link>'s event prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link."
    ), Ie = !0)), this.tag === "a")
      w.on = y, w.attrs = { href: c, "aria-current": g };
    else {
      var C = ot(this.$slots.default);
      if (C) {
        C.isStatic = !1;
        var E = C.data = S({}, C.data);
        E.on = E.on || {};
        for (var $ in E.on) {
          var M = E.on[$];
          $ in y && (E.on[$] = Array.isArray(M) ? M : [M]);
        }
        for (var H in y)
          H in E.on ? E.on[H].push(y[H]) : E.on[H] = _;
        var Se = C.data.attrs = S({}, C.data.attrs);
        Se.href = c, Se["aria-current"] = g;
      } else
        w.on = y;
    }
    return e(this.tag, w, this.$slots.default);
  }
};
function Ve(t) {
  if (!(t.metaKey || t.altKey || t.ctrlKey || t.shiftKey) && !t.defaultPrevented && !(t.button !== void 0 && t.button !== 0)) {
    if (t.currentTarget && t.currentTarget.getAttribute) {
      var e = t.currentTarget.getAttribute("target");
      if (/\b_blank\b/i.test(e))
        return;
    }
    return t.preventDefault && t.preventDefault(), !0;
  }
}
function ot(t) {
  if (t) {
    for (var e, r = 0; r < t.length; r++)
      if (e = t[r], e.tag === "a" || e.children && (e = ot(e.children)))
        return e;
  }
}
var ne;
function ie(t) {
  if (!(ie.installed && ne === t)) {
    ie.installed = !0, ne = t;
    var e = function(i) {
      return i !== void 0;
    }, r = function(i, s) {
      var o = i.$options._parentVnode;
      e(o) && e(o = o.data) && e(o = o.registerRouteInstance) && o(i, s);
    };
    t.mixin({
      beforeCreate: function() {
        e(this.$options.router) ? (this._routerRoot = this, this._router = this.$options.router, this._router.init(this), t.util.defineReactive(this, "_route", this._router.history.current)) : this._routerRoot = this.$parent && this.$parent._routerRoot || this, r(this, this);
      },
      destroyed: function() {
        r(this);
      }
    }), Object.defineProperty(t.prototype, "$router", {
      get: function() {
        return this._routerRoot._router;
      }
    }), Object.defineProperty(t.prototype, "$route", {
      get: function() {
        return this._routerRoot._route;
      }
    }), t.component("RouterView", sr), t.component("RouterLink", st);
    var n = t.config.optionMergeStrategies;
    n.beforeRouteEnter = n.beforeRouteLeave = n.beforeRouteUpdate = n.created;
  }
}
var W = typeof window < "u";
function G(t, e, r, n, i) {
  var s = e || [], o = r || /* @__PURE__ */ Object.create(null), a = n || /* @__PURE__ */ Object.create(null);
  t.forEach(function(h) {
    de(s, o, a, h, i);
  });
  for (var c = 0, u = s.length; c < u; c++)
    s[c] === "*" && (s.push(s.splice(c, 1)[0]), u--, c--);
  if (process.env.NODE_ENV === "development") {
    var d = s.filter(function(h) {
      return h && h.charAt(0) !== "*" && h.charAt(0) !== "/";
    });
    if (d.length > 0) {
      var m = d.map(function(h) {
        return "- " + h;
      }).join(`
`);
      P(!1, `Non-nested routes must include a leading slash character. Fix the following routes: 
` + m);
    }
  }
  return {
    pathList: s,
    pathMap: o,
    nameMap: a
  };
}
function de(t, e, r, n, i, s) {
  var o = n.path, a = n.name;
  process.env.NODE_ENV !== "production" && (I(o != null, '"path" is required in a route configuration.'), I(
    typeof n.component != "string",
    'route config "component" for path: ' + String(
      o || a
    ) + " cannot be a string id. Use an actual component instead."
  ), P(
    // eslint-disable-next-line no-control-regex
    !/[^\u0000-\u007F]+/.test(o),
    'Route with path "' + o + '" contains unencoded characters, make sure your path is correctly encoded before passing it to the router. Use encodeURI to encode static segments of your path.'
  ));
  var c = n.pathToRegexpOptions || {}, u = Pr(o, i, c.strict);
  typeof n.caseSensitive == "boolean" && (c.sensitive = n.caseSensitive);
  var d = {
    path: u,
    regex: Rr(u, c),
    components: n.components || { default: n.component },
    alias: n.alias ? typeof n.alias == "string" ? [n.alias] : n.alias : [],
    instances: {},
    enteredCbs: {},
    name: a,
    parent: i,
    matchAs: s,
    redirect: n.redirect,
    beforeEnter: n.beforeEnter,
    meta: n.meta || {},
    props: n.props == null ? {} : n.components ? n.props : { default: n.props }
  };
  if (n.children && (process.env.NODE_ENV !== "production" && n.name && !n.redirect && n.children.some(function(l) {
    return /^\/?$/.test(l.path);
  }) && P(
    !1,
    "Named Route '" + n.name + `' has a default child route. When navigating to this named route (:to="{name: '` + n.name + `'}"), the default child route will not be rendered. Remove the name from this route and use the name of the default child route for named links instead.`
  ), n.children.forEach(function(l) {
    var f = s ? L(s + "/" + l.path) : void 0;
    de(t, e, r, l, d, f);
  })), e[d.path] || (t.push(d.path), e[d.path] = d), n.alias !== void 0)
    for (var m = Array.isArray(n.alias) ? n.alias : [n.alias], h = 0; h < m.length; ++h) {
      var v = m[h];
      if (process.env.NODE_ENV !== "production" && v === o) {
        P(
          !1,
          'Found an alias with the same value as the path: "' + o + '". You have to remove that alias. It will be ignored in development.'
        );
        continue;
      }
      var p = {
        path: v,
        children: n.children
      };
      de(
        t,
        e,
        r,
        p,
        i,
        d.path || "/"
        // matchAs
      );
    }
  a && (r[a] ? process.env.NODE_ENV !== "production" && !s && P(
    !1,
    'Duplicate named routes definition: { name: "' + a + '", path: "' + d.path + '" }'
  ) : r[a] = d);
}
function Rr(t, e) {
  var r = q(t, [], e);
  if (process.env.NODE_ENV !== "production") {
    var n = /* @__PURE__ */ Object.create(null);
    r.keys.forEach(function(i) {
      P(
        !n[i.name],
        'Duplicate param keys in route with path: "' + t + '"'
      ), n[i.name] = !0;
    });
  }
  return r;
}
function Pr(t, e, r) {
  return r || (t = t.replace(/\/$/, "")), t[0] === "/" || e == null ? t : L(e.path + "/" + t);
}
function Cr(t, e) {
  var r = G(t), n = r.pathList, i = r.pathMap, s = r.nameMap;
  function o(v) {
    G(v, n, i, s);
  }
  function a(v, p) {
    var l = typeof v != "object" ? s[v] : void 0;
    G([p || v], n, i, s, l), l && l.alias.length && G(
      // $flow-disable-line route is defined if parent is
      l.alias.map(function(f) {
        return { path: f, children: [p] };
      }),
      n,
      i,
      s,
      l
    );
  }
  function c() {
    return n.map(function(v) {
      return i[v];
    });
  }
  function u(v, p, l) {
    var f = Re(v, p, !1, e), g = f.name;
    if (g) {
      var _ = s[g];
      if (process.env.NODE_ENV !== "production" && P(_, "Route with name '" + g + "' does not exist"), !_)
        return h(null, f);
      var y = _.regex.keys.filter(function($) {
        return !$.optional;
      }).map(function($) {
        return $.name;
      });
      if (typeof f.params != "object" && (f.params = {}), p && typeof p.params == "object")
        for (var w in p.params)
          !(w in f.params) && y.indexOf(w) > -1 && (f.params[w] = p.params[w]);
      return f.path = Z(_.path, f.params, 'named route "' + g + '"'), h(_, f, l);
    } else if (f.path) {
      f.params = {};
      for (var R = 0; R < n.length; R++) {
        var C = n[R], E = i[C];
        if (Er(E.regex, f.path, f.params))
          return h(E, f, l);
      }
    }
    return h(null, f);
  }
  function d(v, p) {
    var l = v.redirect, f = typeof l == "function" ? l(te(v, p, null, e)) : l;
    if (typeof f == "string" && (f = { path: f }), !f || typeof f != "object")
      return process.env.NODE_ENV !== "production" && P(
        !1,
        "invalid redirect option: " + JSON.stringify(f)
      ), h(null, p);
    var g = f, _ = g.name, y = g.path, w = p.query, R = p.hash, C = p.params;
    if (w = g.hasOwnProperty("query") ? g.query : w, R = g.hasOwnProperty("hash") ? g.hash : R, C = g.hasOwnProperty("params") ? g.params : C, _) {
      var E = s[_];
      return process.env.NODE_ENV !== "production" && I(E, 'redirect failed: named route "' + _ + '" not found.'), u({
        _normalized: !0,
        name: _,
        query: w,
        hash: R,
        params: C
      }, void 0, p);
    } else if (y) {
      var $ = kr(y, v), M = Z($, C, 'redirect route with path "' + $ + '"');
      return u({
        _normalized: !0,
        path: M,
        query: w,
        hash: R
      }, void 0, p);
    } else
      return process.env.NODE_ENV !== "production" && P(!1, "invalid redirect option: " + JSON.stringify(f)), h(null, p);
  }
  function m(v, p, l) {
    var f = Z(l, p.params, 'aliased route with path "' + l + '"'), g = u({
      _normalized: !0,
      path: f
    });
    if (g) {
      var _ = g.matched, y = _[_.length - 1];
      return p.params = g.params, h(y, p);
    }
    return h(null, p);
  }
  function h(v, p, l) {
    return v && v.redirect ? d(v, l || p) : v && v.matchAs ? m(v, p, v.matchAs) : te(v, p, l, e);
  }
  return {
    match: u,
    addRoute: a,
    getRoutes: c,
    addRoutes: o
  };
}
function Er(t, e, r) {
  var n = e.match(t);
  if (n) {
    if (!r)
      return !0;
  } else
    return !1;
  for (var i = 1, s = n.length; i < s; ++i) {
    var o = t.keys[i - 1];
    o && (r[o.name || "pathMatch"] = typeof n[i] == "string" ? he(n[i]) : n[i]);
  }
  return !0;
}
function kr(t, e) {
  return tt(t, e.parent ? e.parent.path : "/", !0);
}
var Sr = W && window.performance && window.performance.now ? window.performance : Date;
function at() {
  return Sr.now().toFixed(3);
}
var ct = at();
function ae() {
  return ct;
}
function ut(t) {
  return ct = t;
}
var lt = /* @__PURE__ */ Object.create(null);
function ft() {
  "scrollRestoration" in window.history && (window.history.scrollRestoration = "manual");
  var t = window.location.protocol + "//" + window.location.host, e = window.location.href.replace(t, ""), r = S({}, window.history.state);
  return r.key = ae(), window.history.replaceState(r, "", e), window.addEventListener("popstate", je), function() {
    window.removeEventListener("popstate", je);
  };
}
function O(t, e, r, n) {
  if (t.app) {
    var i = t.options.scrollBehavior;
    i && (process.env.NODE_ENV !== "production" && I(typeof i == "function", "scrollBehavior must be a function"), t.app.$nextTick(function() {
      var s = xr(), o = i.call(
        t,
        e,
        r,
        n ? s : null
      );
      o && (typeof o.then == "function" ? o.then(function(a) {
        Me(a, s);
      }).catch(function(a) {
        process.env.NODE_ENV !== "production" && I(!1, a.toString());
      }) : Me(o, s));
    }));
  }
}
function ht() {
  var t = ae();
  t && (lt[t] = {
    x: window.pageXOffset,
    y: window.pageYOffset
  });
}
function je(t) {
  ht(), t.state && t.state.key && ut(t.state.key);
}
function xr() {
  var t = ae();
  if (t)
    return lt[t];
}
function $r(t, e) {
  var r = document.documentElement, n = r.getBoundingClientRect(), i = t.getBoundingClientRect();
  return {
    x: i.left - n.left - e.x,
    y: i.top - n.top - e.y
  };
}
function Be(t) {
  return B(t.x) || B(t.y);
}
function qe(t) {
  return {
    x: B(t.x) ? t.x : window.pageXOffset,
    y: B(t.y) ? t.y : window.pageYOffset
  };
}
function Nr(t) {
  return {
    x: B(t.x) ? t.x : 0,
    y: B(t.y) ? t.y : 0
  };
}
function B(t) {
  return typeof t == "number";
}
var Lr = /^#\d/;
function Me(t, e) {
  var r = typeof t == "object";
  if (r && typeof t.selector == "string") {
    var n = Lr.test(t.selector) ? document.getElementById(t.selector.slice(1)) : document.querySelector(t.selector);
    if (n) {
      var i = t.offset && typeof t.offset == "object" ? t.offset : {};
      i = Nr(i), e = $r(n, i);
    } else
      Be(t) && (e = qe(t));
  } else
    r && Be(t) && (e = qe(t));
  e && ("scrollBehavior" in document.documentElement.style ? window.scrollTo({
    left: e.x,
    top: e.y,
    // $flow-disable-line
    behavior: t.behavior
  }) : window.scrollTo(e.x, e.y));
}
var T = W && function() {
  var t = window.navigator.userAgent;
  return (t.indexOf("Android 2.") !== -1 || t.indexOf("Android 4.0") !== -1) && t.indexOf("Mobile Safari") !== -1 && t.indexOf("Chrome") === -1 && t.indexOf("Windows Phone") === -1 ? !1 : window.history && typeof window.history.pushState == "function";
}();
function se(t, e) {
  ht();
  var r = window.history;
  try {
    if (e) {
      var n = S({}, r.state);
      n.key = ae(), r.replaceState(n, "", t);
    } else
      r.pushState({ key: ut(at()) }, "", t);
  } catch {
    window.location[e ? "replace" : "assign"](t);
  }
}
function ve(t) {
  se(t, !0);
}
var V = {
  redirected: 2,
  aborted: 4,
  cancelled: 8,
  duplicated: 16
};
function Or(t, e) {
  return ce(
    t,
    e,
    V.redirected,
    'Redirected when going from "' + t.fullPath + '" to "' + Vr(
      e
    ) + '" via a navigation guard.'
  );
}
function Tr(t, e) {
  var r = ce(
    t,
    e,
    V.duplicated,
    'Avoided redundant navigation to current location: "' + t.fullPath + '".'
  );
  return r.name = "NavigationDuplicated", r;
}
function Ue(t, e) {
  return ce(
    t,
    e,
    V.cancelled,
    'Navigation cancelled from "' + t.fullPath + '" to "' + e.fullPath + '" with a new navigation.'
  );
}
function Ar(t, e) {
  return ce(
    t,
    e,
    V.aborted,
    'Navigation aborted from "' + t.fullPath + '" to "' + e.fullPath + '" via a navigation guard.'
  );
}
function ce(t, e, r, n) {
  var i = new Error(n);
  return i._isRouter = !0, i.from = t, i.to = e, i.type = r, i;
}
var Ir = ["params", "query", "hash"];
function Vr(t) {
  if (typeof t == "string")
    return t;
  if ("path" in t)
    return t.path;
  var e = {};
  return Ir.forEach(function(r) {
    r in t && (e[r] = t[r]);
  }), JSON.stringify(e, null, 2);
}
function oe(t) {
  return Object.prototype.toString.call(t).indexOf("Error") > -1;
}
function ue(t, e) {
  return oe(t) && t._isRouter && (e == null || t.type === e);
}
function De(t, e, r) {
  var n = function(i) {
    i >= t.length ? r() : t[i] ? e(t[i], function() {
      n(i + 1);
    }) : n(i + 1);
  };
  n(0);
}
function jr(t) {
  return function(e, r, n) {
    var i = !1, s = 0, o = null;
    pt(t, function(a, c, u, d) {
      if (typeof a == "function" && a.cid === void 0) {
        i = !0, s++;
        var m = ze(function(l) {
          qr(l) && (l = l.default), a.resolved = typeof l == "function" ? l : ne.extend(l), u.components[d] = l, s--, s <= 0 && n();
        }), h = ze(function(l) {
          var f = "Failed to resolve async component " + d + ": " + l;
          process.env.NODE_ENV !== "production" && P(!1, f), o || (o = oe(l) ? l : new Error(f), n(o));
        }), v;
        try {
          v = a(m, h);
        } catch (l) {
          h(l);
        }
        if (v)
          if (typeof v.then == "function")
            v.then(m, h);
          else {
            var p = v.component;
            p && typeof p.then == "function" && p.then(m, h);
          }
      }
    }), i || n();
  };
}
function pt(t, e) {
  return dt(t.map(function(r) {
    return Object.keys(r.components).map(function(n) {
      return e(
        r.components[n],
        r.instances[n],
        r,
        n
      );
    });
  }));
}
function dt(t) {
  return Array.prototype.concat.apply([], t);
}
var Br = typeof Symbol == "function" && typeof Symbol.toStringTag == "symbol";
function qr(t) {
  return t.__esModule || Br && t[Symbol.toStringTag] === "Module";
}
function ze(t) {
  var e = !1;
  return function() {
    for (var r = [], n = arguments.length; n--; )
      r[n] = arguments[n];
    if (!e)
      return e = !0, t.apply(this, r);
  };
}
var x = function(e, r) {
  this.router = e, this.base = Mr(r), this.current = A, this.pending = null, this.ready = !1, this.readyCbs = [], this.readyErrorCbs = [], this.errorCbs = [], this.listeners = [];
};
x.prototype.listen = function(e) {
  this.cb = e;
};
x.prototype.onReady = function(e, r) {
  this.ready ? e() : (this.readyCbs.push(e), r && this.readyErrorCbs.push(r));
};
x.prototype.onError = function(e) {
  this.errorCbs.push(e);
};
x.prototype.transitionTo = function(e, r, n) {
  var i = this, s;
  try {
    s = this.router.match(e, this.current);
  } catch (a) {
    throw this.errorCbs.forEach(function(c) {
      c(a);
    }), a;
  }
  var o = this.current;
  this.confirmTransition(
    s,
    function() {
      i.updateRoute(s), r && r(s), i.ensureURL(), i.router.afterHooks.forEach(function(a) {
        a && a(s, o);
      }), i.ready || (i.ready = !0, i.readyCbs.forEach(function(a) {
        a(s);
      }));
    },
    function(a) {
      n && n(a), a && !i.ready && (!ue(a, V.redirected) || o !== A) && (i.ready = !0, i.readyErrorCbs.forEach(function(c) {
        c(a);
      }));
    }
  );
};
x.prototype.confirmTransition = function(e, r, n) {
  var i = this, s = this.current;
  this.pending = e;
  var o = function(l) {
    !ue(l) && oe(l) && (i.errorCbs.length ? i.errorCbs.forEach(function(f) {
      f(l);
    }) : (process.env.NODE_ENV !== "production" && P(!1, "uncaught error during route navigation:"), console.error(l))), n && n(l);
  }, a = e.matched.length - 1, c = s.matched.length - 1;
  if (Ye(e, s) && // in the case the route map has been dynamically appended to
  a === c && e.matched[a] === s.matched[c])
    return this.ensureURL(), e.hash && O(this.router, s, e, !1), o(Tr(s, e));
  var u = Ur(
    this.current.matched,
    e.matched
  ), d = u.updated, m = u.deactivated, h = u.activated, v = [].concat(
    // in-component leave guards
    zr(m),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    Fr(d),
    // in-config enter guards
    h.map(function(l) {
      return l.beforeEnter;
    }),
    // async components
    jr(h)
  ), p = function(l, f) {
    if (i.pending !== e)
      return o(Ue(s, e));
    try {
      l(e, s, function(g) {
        g === !1 ? (i.ensureURL(!0), o(Ar(s, e))) : oe(g) ? (i.ensureURL(!0), o(g)) : typeof g == "string" || typeof g == "object" && (typeof g.path == "string" || typeof g.name == "string") ? (o(Or(s, e)), typeof g == "object" && g.replace ? i.replace(g) : i.push(g)) : f(g);
      });
    } catch (g) {
      o(g);
    }
  };
  De(v, p, function() {
    var l = Wr(h), f = l.concat(i.router.resolveHooks);
    De(f, p, function() {
      if (i.pending !== e)
        return o(Ue(s, e));
      i.pending = null, r(e), i.router.app && i.router.app.$nextTick(function() {
        et(e);
      });
    });
  });
};
x.prototype.updateRoute = function(e) {
  this.current = e, this.cb && this.cb(e);
};
x.prototype.setupListeners = function() {
};
x.prototype.teardown = function() {
  this.listeners.forEach(function(e) {
    e();
  }), this.listeners = [], this.current = A, this.pending = null;
};
function Mr(t) {
  if (!t)
    if (W) {
      var e = document.querySelector("base");
      t = e && e.getAttribute("href") || "/", t = t.replace(/^https?:\/\/[^\/]+/, "");
    } else
      t = "/";
  return t.charAt(0) !== "/" && (t = "/" + t), t.replace(/\/$/, "");
}
function Ur(t, e) {
  var r, n = Math.max(t.length, e.length);
  for (r = 0; r < n && t[r] === e[r]; r++)
    ;
  return {
    updated: e.slice(0, r),
    activated: e.slice(r),
    deactivated: t.slice(r)
  };
}
function Pe(t, e, r, n) {
  var i = pt(t, function(s, o, a, c) {
    var u = Dr(s, e);
    if (u)
      return Array.isArray(u) ? u.map(function(d) {
        return r(d, o, a, c);
      }) : r(u, o, a, c);
  });
  return dt(n ? i.reverse() : i);
}
function Dr(t, e) {
  return typeof t != "function" && (t = ne.extend(t)), t.options[e];
}
function zr(t) {
  return Pe(t, "beforeRouteLeave", vt, !0);
}
function Fr(t) {
  return Pe(t, "beforeRouteUpdate", vt);
}
function vt(t, e) {
  if (e)
    return function() {
      return t.apply(e, arguments);
    };
}
function Wr(t) {
  return Pe(
    t,
    "beforeRouteEnter",
    function(e, r, n, i) {
      return Hr(e, n, i);
    }
  );
}
function Hr(t, e, r) {
  return function(i, s, o) {
    return t(i, s, function(a) {
      typeof a == "function" && (e.enteredCbs[r] || (e.enteredCbs[r] = []), e.enteredCbs[r].push(a)), o(a);
    });
  };
}
var mt = /* @__PURE__ */ function(t) {
  function e(r, n) {
    t.call(this, r, n), this._startLocation = D(this.base);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.setupListeners = function() {
    var n = this;
    if (!(this.listeners.length > 0)) {
      var i = this.router, s = i.options.scrollBehavior, o = T && s;
      o && this.listeners.push(ft());
      var a = function() {
        var c = n.current, u = D(n.base);
        n.current === A && u === n._startLocation || n.transitionTo(u, function(d) {
          o && O(i, d, c, !0);
        });
      };
      window.addEventListener("popstate", a), this.listeners.push(function() {
        window.removeEventListener("popstate", a);
      });
    }
  }, e.prototype.go = function(n) {
    window.history.go(n);
  }, e.prototype.push = function(n, i, s) {
    var o = this, a = this, c = a.current;
    this.transitionTo(n, function(u) {
      se(L(o.base + u.fullPath)), O(o.router, u, c, !1), i && i(u);
    }, s);
  }, e.prototype.replace = function(n, i, s) {
    var o = this, a = this, c = a.current;
    this.transitionTo(n, function(u) {
      ve(L(o.base + u.fullPath)), O(o.router, u, c, !1), i && i(u);
    }, s);
  }, e.prototype.ensureURL = function(n) {
    if (D(this.base) !== this.current.fullPath) {
      var i = L(this.base + this.current.fullPath);
      n ? se(i) : ve(i);
    }
  }, e.prototype.getCurrentLocation = function() {
    return D(this.base);
  }, e;
}(x);
function D(t) {
  var e = window.location.pathname, r = e.toLowerCase(), n = t.toLowerCase();
  return t && (r === n || r.indexOf(L(n + "/")) === 0) && (e = e.slice(t.length)), (e || "/") + window.location.search + window.location.hash;
}
var gt = /* @__PURE__ */ function(t) {
  function e(r, n, i) {
    t.call(this, r, n), !(i && Gr(this.base)) && Fe();
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.setupListeners = function() {
    var n = this;
    if (!(this.listeners.length > 0)) {
      var i = this.router, s = i.options.scrollBehavior, o = T && s;
      o && this.listeners.push(ft());
      var a = function() {
        var u = n.current;
        Fe() && n.transitionTo(J(), function(d) {
          o && O(n.router, d, u, !0), T || X(d.fullPath);
        });
      }, c = T ? "popstate" : "hashchange";
      window.addEventListener(
        c,
        a
      ), this.listeners.push(function() {
        window.removeEventListener(c, a);
      });
    }
  }, e.prototype.push = function(n, i, s) {
    var o = this, a = this, c = a.current;
    this.transitionTo(
      n,
      function(u) {
        We(u.fullPath), O(o.router, u, c, !1), i && i(u);
      },
      s
    );
  }, e.prototype.replace = function(n, i, s) {
    var o = this, a = this, c = a.current;
    this.transitionTo(
      n,
      function(u) {
        X(u.fullPath), O(o.router, u, c, !1), i && i(u);
      },
      s
    );
  }, e.prototype.go = function(n) {
    window.history.go(n);
  }, e.prototype.ensureURL = function(n) {
    var i = this.current.fullPath;
    J() !== i && (n ? We(i) : X(i));
  }, e.prototype.getCurrentLocation = function() {
    return J();
  }, e;
}(x);
function Gr(t) {
  var e = D(t);
  if (!/^\/#/.test(e))
    return window.location.replace(L(t + "/#" + e)), !0;
}
function Fe() {
  var t = J();
  return t.charAt(0) === "/" ? !0 : (X("/" + t), !1);
}
function J() {
  var t = window.location.href, e = t.indexOf("#");
  return e < 0 ? "" : (t = t.slice(e + 1), t);
}
function me(t) {
  var e = window.location.href, r = e.indexOf("#"), n = r >= 0 ? e.slice(0, r) : e;
  return n + "#" + t;
}
function We(t) {
  T ? se(me(t)) : window.location.hash = t;
}
function X(t) {
  T ? ve(me(t)) : window.location.replace(me(t));
}
var Qr = /* @__PURE__ */ function(t) {
  function e(r, n) {
    t.call(this, r, n), this.stack = [], this.index = -1;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.push = function(n, i, s) {
    var o = this;
    this.transitionTo(
      n,
      function(a) {
        o.stack = o.stack.slice(0, o.index + 1).concat(a), o.index++, i && i(a);
      },
      s
    );
  }, e.prototype.replace = function(n, i, s) {
    var o = this;
    this.transitionTo(
      n,
      function(a) {
        o.stack = o.stack.slice(0, o.index).concat(a), i && i(a);
      },
      s
    );
  }, e.prototype.go = function(n) {
    var i = this, s = this.index + n;
    if (!(s < 0 || s >= this.stack.length)) {
      var o = this.stack[s];
      this.confirmTransition(
        o,
        function() {
          var a = i.current;
          i.index = s, i.updateRoute(o), i.router.afterHooks.forEach(function(c) {
            c && c(o, a);
          });
        },
        function(a) {
          ue(a, V.duplicated) && (i.index = s);
        }
      );
    }
  }, e.prototype.getCurrentLocation = function() {
    var n = this.stack[this.stack.length - 1];
    return n ? n.fullPath : "/";
  }, e.prototype.ensureURL = function() {
  }, e;
}(x), b = function t(e) {
  e === void 0 && (e = {}), process.env.NODE_ENV !== "production" && P(this instanceof t, "Router must be called with the new operator."), this.app = null, this.apps = [], this.options = e, this.beforeHooks = [], this.resolveHooks = [], this.afterHooks = [], this.matcher = Cr(e.routes || [], this);
  var r = e.mode || "hash";
  switch (this.fallback = r === "history" && !T && e.fallback !== !1, this.fallback && (r = "hash"), W || (r = "abstract"), this.mode = r, r) {
    case "history":
      this.history = new mt(this, e.base);
      break;
    case "hash":
      this.history = new gt(this, e.base, this.fallback);
      break;
    case "abstract":
      this.history = new Qr(this, e.base);
      break;
    default:
      process.env.NODE_ENV !== "production" && I(!1, "invalid mode: " + r);
  }
}, yt = { currentRoute: { configurable: !0 } };
b.prototype.match = function(e, r, n) {
  return this.matcher.match(e, r, n);
};
yt.currentRoute.get = function() {
  return this.history && this.history.current;
};
b.prototype.init = function(e) {
  var r = this;
  if (process.env.NODE_ENV !== "production" && I(
    ie.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` before creating root instance."
  ), this.apps.push(e), e.$once("hook:destroyed", function() {
    var o = r.apps.indexOf(e);
    o > -1 && r.apps.splice(o, 1), r.app === e && (r.app = r.apps[0] || null), r.app || r.history.teardown();
  }), !this.app) {
    this.app = e;
    var n = this.history;
    if (n instanceof mt || n instanceof gt) {
      var i = function(o) {
        var a = n.current, c = r.options.scrollBehavior, u = T && c;
        u && "fullPath" in o && O(r, o, a, !1);
      }, s = function(o) {
        n.setupListeners(), i(o);
      };
      n.transitionTo(
        n.getCurrentLocation(),
        s,
        s
      );
    }
    n.listen(function(o) {
      r.apps.forEach(function(a) {
        a._route = o;
      });
    });
  }
};
b.prototype.beforeEach = function(e) {
  return Ce(this.beforeHooks, e);
};
b.prototype.beforeResolve = function(e) {
  return Ce(this.resolveHooks, e);
};
b.prototype.afterEach = function(e) {
  return Ce(this.afterHooks, e);
};
b.prototype.onReady = function(e, r) {
  this.history.onReady(e, r);
};
b.prototype.onError = function(e) {
  this.history.onError(e);
};
b.prototype.push = function(e, r, n) {
  var i = this;
  if (!r && !n && typeof Promise < "u")
    return new Promise(function(s, o) {
      i.history.push(e, s, o);
    });
  this.history.push(e, r, n);
};
b.prototype.replace = function(e, r, n) {
  var i = this;
  if (!r && !n && typeof Promise < "u")
    return new Promise(function(s, o) {
      i.history.replace(e, s, o);
    });
  this.history.replace(e, r, n);
};
b.prototype.go = function(e) {
  this.history.go(e);
};
b.prototype.back = function() {
  this.go(-1);
};
b.prototype.forward = function() {
  this.go(1);
};
b.prototype.getMatchedComponents = function(e) {
  var r = e ? e.matched ? e : this.resolve(e).route : this.currentRoute;
  return r ? [].concat.apply(
    [],
    r.matched.map(function(n) {
      return Object.keys(n.components).map(function(i) {
        return n.components[i];
      });
    })
  ) : [];
};
b.prototype.resolve = function(e, r, n) {
  r = r || this.history.current;
  var i = Re(e, r, n, this), s = this.match(i, r), o = s.redirectedFrom || s.fullPath, a = this.history.base, c = Kr(a, o, this.mode);
  return {
    location: i,
    route: s,
    href: c,
    // for backwards compat
    normalizedTo: i,
    resolved: s
  };
};
b.prototype.getRoutes = function() {
  return this.matcher.getRoutes();
};
b.prototype.addRoute = function(e, r) {
  this.matcher.addRoute(e, r), this.history.current !== A && this.history.transitionTo(this.history.getCurrentLocation());
};
b.prototype.addRoutes = function(e) {
  process.env.NODE_ENV !== "production" && P(!1, "router.addRoutes() is deprecated and has been removed in Vue Router 4. Use router.addRoute() instead."), this.matcher.addRoutes(e), this.history.current !== A && this.history.transitionTo(this.history.getCurrentLocation());
};
Object.defineProperties(b.prototype, yt);
function Ce(t, e) {
  return t.push(e), function() {
    var r = t.indexOf(e);
    r > -1 && t.splice(r, 1);
  };
}
function Kr(t, e, r) {
  var n = r === "hash" ? "#" + e : e;
  return t ? L(t + "/" + n) : n;
}
b.install = ie;
b.version = "3.6.5";
b.isNavigationFailure = ue;
b.NavigationFailureType = V;
b.START_LOCATION = A;
W && window.Vue && window.Vue.use(b);
const vi = /(\s|^)(https?:\/\/)([-A-Z0-9+_.]+(?::[0-9]+)?(?:\/[-A-Z0-9+&@#%?=~_|!:,.;()]*)*)(\s|$)/ig, He = /(\s|\(|^)((https?:\/\/)([-A-Z0-9+_.]+[-A-Z0-9]+(?::[0-9]+)?(?:\/[-A-Z0-9+&@#%?=~_|!:,.;()]*)*))(?=\s|\)|$)/ig, Zr = {
  name: "NcLink",
  props: {
    href: {
      type: String,
      required: !0
    }
  },
  render(t) {
    return t("a", {
      attrs: {
        href: this.href,
        rel: "noopener noreferrer",
        target: "_blank",
        class: "rich-text--external-link"
      }
    }, [this.href.trim()]);
  }
}, mi = function({ autolink: t, useMarkdown: e, useExtendedMarkdown: r }) {
  return function(n) {
    r || !e || !t || Bt(n, (i) => i.type === "text", (i, s, o) => {
      let a = Jr(i.value);
      return a = a.map((c) => typeof c == "string" ? fe("text", c) : fe("link", {
        url: c.props.href
      }, [fe("text", c.props.href)])).filter((c) => c), o.children.splice(s, 1, ...a.flat()), [qt, s + a.flat().length];
    });
  };
}, Jr = (t) => {
  let e = He.exec(t);
  const r = [];
  let n = 0;
  for (; e !== null; ) {
    let s = e[2], o, a = t.substring(n, e.index + e[1].length);
    s[0] === " " && (a += s[0], s = s.substring(1).trim());
    const c = s[s.length - 1];
    (c === "." || c === "," || c === ";" || e[0][0] === "(" && c === ")") && (s = s.substring(0, s.length - 1), o = c), r.push(a), r.push({ component: Zr, props: { href: s } }), o && r.push(o), n = e.index + e[0].length, e = He.exec(t);
  }
  r.push(t.substring(n));
  const i = r.map((s) => typeof s == "string" ? s : s.props.href).join("");
  return t === i ? r : (console.error("Failed to reassemble the chunked text: " + t), t);
}, Xr = (t, e) => {
  if (!t || !e.includes(Vt()))
    return null;
  const r = t.getRoutes().map((n) => new RegExp(n.regex.source.slice(1, -1), n.regex.flags));
  for (const n of r) {
    const i = e.search(n);
    if (i !== -1)
      return e.slice(i);
  }
}, Yr = {
  name: "NcReferenceWidget",
  props: {
    reference: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      compact: 3
    };
  },
  computed: {
    hasCustomWidget() {
      return Pt(this.reference.richObjectType);
    },
    noAccess() {
      return this.reference && !this.reference.accessible;
    },
    descriptionStyle() {
      if (this.compact === 0)
        return {
          display: "none"
        };
      const t = this.compact < 4 ? this.compact : 3;
      return {
        lineClamp: t,
        webkitLineClamp: t
      };
    },
    compactLink() {
      const t = this.reference.openGraphObject.link;
      return t ? t.startsWith("https://") ? t.substring(8) : t.startsWith("http://") ? t.substring(7) : t : "";
    },
    route() {
      return Xr(this.$router, this.reference.openGraphObject.link);
    },
    referenceWidgetLinkComponent() {
      return this.route ? st : "a";
    },
    referenceWidgetLinkProps() {
      return this.route ? { to: this.route } : { href: this.reference.openGraphObject.link, target: "_blank" };
    }
  },
  mounted() {
    this.renderWidget(), Mt(this.$el, (t) => {
      t[0].contentRect.width < 450 ? this.compact = 0 : t[0].contentRect.width < 550 ? this.compact = 1 : t[0].contentRect.width < 650 ? this.compact = 2 : this.compact = 3;
    });
  },
  beforeDestroy() {
    Ct(this.reference.richObjectType, this.$el);
  },
  methods: {
    renderWidget() {
      this.$refs.customWidget && (this.$refs.customWidget.innerHTML = ""), this?.reference?.richObjectType !== "open-graph" && this.$nextTick(() => {
        Et(this.$refs.customWidget, this.reference);
      });
    }
  }
};
var en = function() {
  var e = this, r = e._self._c;
  return r("div", [e.reference && e.hasCustomWidget ? r("div", { staticClass: "widget-custom" }, [r("div", { ref: "customWidget" })]) : !e.noAccess && e.reference && e.reference.openGraphObject && !e.hasCustomWidget ? r(e.referenceWidgetLinkComponent, e._b({ tag: "component", staticClass: "widget-default", attrs: { rel: "noopener noreferrer" } }, "component", e.referenceWidgetLinkProps, !1), [e.reference.openGraphObject.thumb ? r("img", { staticClass: "widget-default--image", attrs: { src: e.reference.openGraphObject.thumb } }) : e._e(), r("div", { staticClass: "widget-default--details" }, [r("p", { staticClass: "widget-default--name" }, [e._v(e._s(e.reference.openGraphObject.name))]), r("p", { staticClass: "widget-default--description", style: e.descriptionStyle }, [e._v(e._s(e.reference.openGraphObject.description))]), r("p", { staticClass: "widget-default--link" }, [e._v(e._s(e.compactLink))])])]) : e._e()], 1);
}, tn = [], rn = /* @__PURE__ */ N(
  Yr,
  en,
  tn,
  !1,
  null,
  "38b1d56a",
  null,
  null
);
const nn = rn.exports, sn = {
  name: "NcCustomPickerElement",
  props: {
    /**
     * The reference provider
     */
    provider: {
      type: Object,
      required: !0
    }
  },
  emits: [
    "cancel",
    "submit"
  ],
  data() {
    return {
      isRegistered: z(this.provider.id),
      renderResult: null
    };
  },
  mounted() {
    this.isRegistered && this.renderElement();
  },
  beforeDestroy() {
    this.isRegistered && kt(this.provider.id, this.$el, this.renderResult);
  },
  methods: {
    renderElement() {
      this.$refs.domElement && (this.$refs.domElement.innerHTML = "");
      const t = St(this.$refs.domElement, { providerId: this.provider.id, accessible: !1 });
      Promise.resolve(t).then((e) => {
        this.renderResult = e, this.renderResult.object?._isVue && this.renderResult.object?.$on && (this.renderResult.object.$on("submit", this.onSubmit), this.renderResult.object.$on("cancel", this.onCancel)), this.renderResult.element.addEventListener("submit", (r) => {
          this.onSubmit(r.detail);
        }), this.renderResult.element.addEventListener("cancel", this.onCancel);
      });
    },
    onSubmit(t) {
      this.$emit("submit", t);
    },
    onCancel() {
      this.$emit("cancel");
    }
  }
};
var on = function() {
  var e = this, r = e._self._c;
  return r("div", { ref: "domElement" });
}, an = [], cn = /* @__PURE__ */ N(
  sn,
  on,
  an,
  !1,
  null,
  "25f1cef8",
  null,
  null
);
const un = cn.exports;
F($t);
const _t = "any-link", bt = {
  id: _t,
  title: k("Any link"),
  icon_url: jt("core", "filetypes/link.svg")
};
window._vue_richtext_reference_providers || (window._vue_richtext_reference_providers = Ze("core", "reference-provider-list", []));
window._vue_richtext_reference_provider_timestamps || (window._vue_richtext_reference_provider_timestamps = Ze("core", "reference-provider-timestamps", {}));
function ln(t) {
  return t === _t ? bt : wt().find((e) => e.id === t);
}
function wt() {
  return window._vue_richtext_reference_providers.filter((t) => {
    const e = !!t.search_providers_ids && t.search_providers_ids.length > 0 || z(t.id);
    return e || console.debug("[smart picker]", t.id, "reference provider is discoverable but does not have any related search provider or custom picker component registered"), e;
  });
}
function fn(t) {
  const e = window._vue_richtext_reference_provider_timestamps;
  return t.sort((r, n) => r.order === n.order ? 0 : r.order > n.order ? 1 : -1).sort((r, n) => {
    const i = e[r.id], s = e[n.id];
    return i === s ? 0 : s === void 0 ? -1 : i === void 0 ? 1 : i > s ? -1 : 1;
  });
}
function hn(t, e = null) {
  const r = wt(), n = t.replace(/[/\-\\^$*+?.()|[\]{}]/g, "\\$&"), i = new RegExp(n, "i"), o = fn(r).filter((c) => c.title.match(i)), a = e ? o.slice(0, e) : o;
  return (t === "" || a.length === 0) && a.push(bt), a;
}
function pn(t) {
  const e = Math.floor(Date.now() / 1e3), r = {
    timestamp: e
  }, n = Y("references/provider/{providerId}", { providerId: t });
  ge.put(n, r).then((i) => {
    window._vue_richtext_reference_provider_timestamps[t] = e;
  });
}
let Ge = 0;
function Rt(t, e) {
  return function() {
    const r = this, n = arguments;
    clearTimeout(Ge), Ge = setTimeout(function() {
      t.apply(r, n);
    }, e || 0);
  };
}
function Ee(t) {
  try {
    return !!new URL(t);
  } catch {
    return !1;
  }
}
F(Ke, Nt);
const dn = {
  name: "LinkVariantIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var vn = function() {
  var e = this, r = e._self._c;
  return r("span", e._b({ staticClass: "material-design-icon link-variant-icon", attrs: { "aria-hidden": e.title ? null : !0, "aria-label": e.title, role: "img" }, on: { click: function(n) {
    return e.$emit("click", n);
  } } }, "span", e.$attrs, !1), [r("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [r("path", { attrs: { d: "M10.59,13.41C11,13.8 11,14.44 10.59,14.83C10.2,15.22 9.56,15.22 9.17,14.83C7.22,12.88 7.22,9.71 9.17,7.76V7.76L12.71,4.22C14.66,2.27 17.83,2.27 19.78,4.22C21.73,6.17 21.73,9.34 19.78,11.29L18.29,12.78C18.3,11.96 18.17,11.14 17.89,10.36L18.36,9.88C19.54,8.71 19.54,6.81 18.36,5.64C17.19,4.46 15.29,4.46 14.12,5.64L10.59,9.17C9.41,10.34 9.41,12.24 10.59,13.41M13.41,9.17C13.8,8.78 14.44,8.78 14.83,9.17C16.78,11.12 16.78,14.29 14.83,16.24V16.24L11.29,19.78C9.34,21.73 6.17,21.73 4.22,19.78C2.27,17.83 2.27,14.66 4.22,12.71L5.71,11.22C5.7,12.04 5.83,12.86 6.11,13.65L5.64,14.12C4.46,15.29 4.46,17.19 5.64,18.36C6.81,19.54 8.71,19.54 9.88,18.36L13.41,14.83C14.59,13.66 14.59,11.76 13.41,10.59C13,10.2 13,9.56 13.41,9.17Z" } }, [e.title ? r("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, mn = [], gn = /* @__PURE__ */ N(
  dn,
  vn,
  mn,
  !1,
  null,
  null,
  null,
  null
);
const ke = gn.exports, yn = {
  name: "NcProviderList",
  components: {
    NcSelect: Xe,
    NcHighlight: Je,
    NcEmptyContent: ye,
    LinkVariantIcon: ke
  },
  emits: [
    "select-provider",
    "submit"
  ],
  data() {
    return {
      selectedProvider: null,
      query: "",
      multiselectPlaceholder: k("Select provider"),
      providerIconAlt: k("Provider icon")
    };
  },
  computed: {
    options() {
      const t = [];
      return this.query !== "" && Ee(this.query) && t.push({
        id: this.query,
        title: this.query,
        isLink: !0
      }), t.push(...hn(this.query)), t;
    }
  },
  methods: {
    focus() {
      setTimeout(() => {
        this.$refs["provider-select"]?.$el?.querySelector("#provider-select-input")?.focus();
      }, 300);
    },
    onProviderSelected(t) {
      t !== null && (t.isLink ? this.$emit("submit", t.title) : this.$emit("select-provider", t), this.selectedProvider = null);
    },
    onSearch(t, e) {
      this.query = t;
    }
  }
};
var _n = function() {
  var e = this, r = e._self._c;
  return r("div", { staticClass: "provider-list" }, [r("NcSelect", { ref: "provider-select", staticClass: "provider-list--select", attrs: { "input-id": "provider-select-input", label: "title", placeholder: e.multiselectPlaceholder, options: e.options, "append-to-body": !1, "clear-search-on-select": !0, "clear-search-on-blur": () => !1, filterable: !1 }, on: { search: e.onSearch, input: e.onProviderSelected }, scopedSlots: e._u([{ key: "option", fn: function(n) {
    return [n.isLink ? r("div", { staticClass: "provider" }, [r("LinkVariantIcon", { staticClass: "link-icon", attrs: { size: 20 } }), r("span", [e._v(e._s(n.title))])], 1) : r("div", { staticClass: "provider" }, [r("img", { staticClass: "provider-icon", attrs: { src: n.icon_url, alt: e.providerIconAlt } }), r("NcHighlight", { staticClass: "option-text", attrs: { search: e.query, text: n.title } })], 1)];
  } }]), model: { value: e.selectedProvider, callback: function(n) {
    e.selectedProvider = n;
  }, expression: "selectedProvider" } }), r("NcEmptyContent", { staticClass: "provider-list--empty-content", scopedSlots: e._u([{ key: "icon", fn: function() {
    return [r("LinkVariantIcon")];
  }, proxy: !0 }]) })], 1);
}, bn = [], wn = /* @__PURE__ */ N(
  yn,
  _n,
  bn,
  !1,
  null,
  "e880790e",
  null,
  null
);
const Rn = wn.exports;
F(Lt);
const Pn = {
  name: "NcRawLinkInput",
  components: {
    LinkVariantIcon: ke,
    NcEmptyContent: ye,
    NcLoadingIcon: Ut,
    NcReferenceWidget: nn,
    NcTextField: Dt
  },
  props: {
    /**
     * The reference provider
     */
    provider: {
      type: Object,
      required: !0
    }
  },
  emits: [
    "submit"
  ],
  data() {
    return {
      inputValue: "",
      loading: !1,
      reference: null,
      abortController: null,
      inputPlaceholder: k("Enter link")
    };
  },
  computed: {
    isLinkValid() {
      return Ee(this.inputValue);
    }
  },
  methods: {
    focus() {
      this.$refs["url-input"].$el.getElementsByTagName("input")[0]?.focus();
    },
    onSubmit(t) {
      const e = t.target.value;
      this.isLinkValid && this.$emit("submit", e);
    },
    onClear() {
      this.inputValue = "", this.reference = null;
    },
    onInput() {
      this.reference = null, this.abortController && this.abortController.abort(), this.isLinkValid && Rt(() => {
        this.updateReference();
      }, 500)();
    },
    updateReference() {
      this.loading = !0, this.abortController = new AbortController(), ge.get(Y("references/resolve", 2) + "?reference=" + encodeURIComponent(this.inputValue), {
        signal: this.abortController.signal
      }).then((t) => {
        this.reference = t.data.ocs.data.references[this.inputValue];
      }).catch((t) => {
        console.error(t);
      }).then(() => {
        this.loading = !1;
      });
    }
  }
};
var Cn = function() {
  var e = this, r = e._self._c;
  return r("div", { staticClass: "raw-link" }, [r("div", { staticClass: "input-wrapper" }, [r("NcTextField", { ref: "url-input", attrs: { value: e.inputValue, "show-trailing-button": e.inputValue !== "", label: e.inputPlaceholder }, on: { "update:value": [function(n) {
    e.inputValue = n;
  }, e.onInput], "trailing-button-click": e.onClear }, nativeOn: { keyup: function(n) {
    return !n.type.indexOf("key") && e._k(n.keyCode, "enter", 13, n.key, "Enter") ? null : e.onSubmit.apply(null, arguments);
  } } }, [e.loading ? r("NcLoadingIcon", { attrs: { size: 16 } }) : r("LinkVariantIcon", { attrs: { size: 16 } })], 1)], 1), e.reference !== null ? r("NcReferenceWidget", { staticClass: "reference-widget", attrs: { reference: e.reference } }) : r("NcEmptyContent", { staticClass: "raw-link--empty-content", scopedSlots: e._u([{ key: "icon", fn: function() {
    return [e.provider.icon_url ? r("img", { staticClass: "provider-icon", attrs: { src: e.provider.icon_url } }) : r("LinkVariantIcon")];
  }, proxy: !0 }]) })], 1);
}, En = [], kn = /* @__PURE__ */ N(
  Pn,
  Cn,
  En,
  !1,
  null,
  "d0ba247a",
  null,
  null
);
const Sn = kn.exports, xn = {
  name: "NcSearchResult",
  components: {
    NcHighlight: Je
  },
  props: {
    /**
     * Unified search result entry
     */
    entry: {
      type: Object,
      required: !0
    },
    /**
     * The query that led to getting this result
     * Used to highlight the entry text
     */
    query: {
      type: String,
      required: !0
    }
  }
};
var $n = function() {
  var e = this, r = e._self._c;
  return r("div", { staticClass: "result" }, [e.entry.icon ? r("div", { staticClass: "result--icon-class", class: { [e.entry.icon]: !0, rounded: e.entry.rounded } }) : r("img", { staticClass: "result--image", class: { rounded: e.entry.rounded }, attrs: { src: e.entry.thumbnailUrl } }), r("div", { staticClass: "result--content" }, [r("span", { staticClass: "result--content--name" }, [r("NcHighlight", { attrs: { search: e.query, text: e.entry.title } })], 1), r("span", { staticClass: "result--content--subline" }, [r("NcHighlight", { attrs: { search: e.query, text: e.entry.subline } })], 1)])]);
}, Nn = [], Ln = /* @__PURE__ */ N(
  xn,
  $n,
  Nn,
  !1,
  null,
  "7a394a58",
  null,
  null
);
const On = Ln.exports;
F(Tt, Ke, Ot);
const Qe = 5, Tn = {
  name: "NcSearch",
  components: {
    LinkVariantIcon: ke,
    DotsHorizontalIcon: zt,
    NcEmptyContent: ye,
    NcSelect: Xe,
    NcSearchResult: On
  },
  props: {
    /**
     * The selected reference provider
     */
    provider: {
      type: Object,
      required: !0
    },
    showEmptyContent: {
      type: Boolean,
      default: !0
    },
    searchPlaceholder: {
      type: String,
      default: null
    }
  },
  emits: [
    "submit"
  ],
  data() {
    return {
      searchQuery: "",
      selectedResult: null,
      resultsBySearchProvider: {},
      searching: !1,
      searchingMoreOf: null,
      abortController: null,
      noOptionsText: k("Start typing to search"),
      providerIconAlt: k("Provider icon")
    };
  },
  computed: {
    mySearchPlaceholder() {
      return this.searchPlaceholder || k("Search");
    },
    searchProviderIds() {
      return this.provider.search_providers_ids;
    },
    options() {
      if (this.searchQuery === "")
        return [];
      const t = [];
      return Ee(this.searchQuery) && t.push(this.rawLinkEntry), t.push(...this.formattedSearchResults), t;
    },
    rawLinkEntry() {
      return {
        id: "rawLinkEntry",
        resourceUrl: this.searchQuery,
        isRawLink: !0
      };
    },
    formattedSearchResults() {
      const t = [];
      return this.searchProviderIds.forEach((e) => {
        if (this.resultsBySearchProvider[e].entries.length > 0) {
          (this.searchProviderIds.length > 1 || this.resultsBySearchProvider[e].entries.length > 1) && t.push({
            id: "groupTitle-" + e,
            name: this.resultsBySearchProvider[e].name,
            isCustomGroupTitle: !0,
            providerId: e
          });
          const r = this.resultsBySearchProvider[e].entries.map((n, i) => ({
            id: "provider-" + e + "-entry-" + i,
            ...n
          }));
          t.push(...r), this.resultsBySearchProvider[e].isPaginated && t.push({
            id: "moreOf-" + e,
            name: this.resultsBySearchProvider[e].name,
            isMore: !0,
            providerId: e,
            isLoading: this.searchingMoreOf === e
          });
        }
      }), t;
    }
  },
  mounted() {
    this.resetResults();
  },
  beforeDestroy() {
    this.cancelSearchRequests();
  },
  methods: {
    t: k,
    resetResults() {
      const t = {};
      this.searchProviderIds.forEach((e) => {
        t[e] = {
          entries: []
        };
      }), this.resultsBySearchProvider = t;
    },
    focus() {
      setTimeout(() => {
        this.$refs["search-select"]?.$el?.querySelector("#search-select-input")?.focus();
      }, 300);
    },
    cancelSearchRequests() {
      this.abortController && this.abortController.abort();
    },
    onSearchInput(t, e) {
      this.searchQuery = t, Rt(() => {
        this.updateSearch();
      }, 500)();
    },
    onSelectResultSelected(t) {
      t !== null && (t.resourceUrl ? (this.cancelSearchRequests(), this.$emit("submit", t.resourceUrl)) : t.isMore && this.searchMoreOf(t.providerId).then(() => {
        this.selectedResult = null;
      }));
    },
    searchMoreOf(t) {
      return this.searchingMoreOf = t, this.cancelSearchRequests(), this.searchProviders(t);
    },
    updateSearch() {
      if (this.cancelSearchRequests(), this.resetResults(), this.searchQuery === "") {
        this.searching = !1;
        return;
      }
      return this.searchProviders();
    },
    searchProviders(t = null) {
      this.abortController = new AbortController(), this.searching = !0;
      const e = t === null ? [...this.searchProviderIds].map((r) => this.searchOneProvider(r)) : [this.searchOneProvider(t, this.resultsBySearchProvider[t]?.cursor ?? null)];
      return Promise.allSettled(e).then((r) => {
        !!r.find((i) => i.status === "rejected" && (i.reason.name === "CanceledError" || i.reason.code === "ERR_CANCELED")) || (this.searching = !1, this.searchingMoreOf = null);
      });
    },
    searchOneProvider(t, e = null) {
      const r = e === null ? Y("search/providers/{providerId}/search?term={term}&limit={limit}", { providerId: t, term: this.searchQuery, limit: Qe }) : Y("search/providers/{providerId}/search?term={term}&limit={limit}&cursor={cursor}", { providerId: t, term: this.searchQuery, limit: Qe, cursor: e });
      return ge.get(r, {
        signal: this.abortController.signal
      }).then((n) => {
        const i = n.data.ocs.data;
        this.resultsBySearchProvider[t].name = i.name, this.resultsBySearchProvider[t].cursor = i.cursor, this.resultsBySearchProvider[t].isPaginated = i.isPaginated, this.resultsBySearchProvider[t].entries.push(...i.entries);
      });
    }
  }
};
var An = function() {
  var e = this, r = e._self._c;
  return r("div", { staticClass: "smart-picker-search", class: { "with-empty-content": e.showEmptyContent } }, [r("NcSelect", { ref: "search-select", staticClass: "smart-picker-search--select", attrs: { "input-id": "search-select-input", label: "name", placeholder: e.mySearchPlaceholder, options: e.options, "append-to-body": !1, "close-on-select": !1, "clear-search-on-select": !1, "clear-search-on-blur": () => !1, "reset-focus-on-options-change": !1, filterable: !1, autoscroll: !0, "reset-on-options-change": !1, loading: e.searching }, on: { search: e.onSearchInput, input: e.onSelectResultSelected }, scopedSlots: e._u([{ key: "option", fn: function(n) {
    return [n.isRawLink ? r("div", { staticClass: "custom-option" }, [r("LinkVariantIcon", { staticClass: "option-simple-icon", attrs: { size: 20 } }), r("span", { staticClass: "option-text" }, [e._v(" " + e._s(e.t("Raw link {options}", { options: n.resourceUrl })) + " ")])], 1) : n.resourceUrl ? r("NcSearchResult", { staticClass: "search-result", attrs: { entry: n, query: e.searchQuery } }) : n.isCustomGroupTitle ? r("span", { staticClass: "custom-option group-name" }, [e.provider.icon_url ? r("img", { staticClass: "provider-icon group-name-icon", attrs: { src: e.provider.icon_url } }) : e._e(), r("span", { staticClass: "option-text" }, [r("strong", [e._v(e._s(n.name))])])]) : n.isMore ? r("span", { class: { "custom-option": !0 } }, [n.isLoading ? r("span", { staticClass: "option-simple-icon icon-loading-small" }) : r("DotsHorizontalIcon", { staticClass: "option-simple-icon", attrs: { size: 20 } }), r("span", { staticClass: "option-text" }, [e._v(" " + e._s(e.t('Load more "{options}"', { options: n.name })) + " ")])], 1) : e._e()];
  } }, { key: "no-options", fn: function() {
    return [e._v(" " + e._s(e.noOptionsText) + " ")];
  }, proxy: !0 }]), model: { value: e.selectedResult, callback: function(n) {
    e.selectedResult = n;
  }, expression: "selectedResult" } }), e.showEmptyContent ? r("NcEmptyContent", { staticClass: "smart-picker-search--empty-content", scopedSlots: e._u([{ key: "icon", fn: function() {
    return [e.provider.icon_url ? r("img", { staticClass: "provider-icon", attrs: { alt: e.providerIconAlt, src: e.provider.icon_url } }) : r("LinkVariantIcon")];
  }, proxy: !0 }], null, !1, 2922132592) }) : e._e()], 1);
}, In = [], Vn = /* @__PURE__ */ N(
  Tn,
  An,
  In,
  !1,
  null,
  "97d196f0",
  null,
  null
);
const jn = Vn.exports, U = {
  providerList: 1,
  standardLinkInput: 2,
  searchInput: 3,
  customElement: 4
}, Bn = {
  name: "NcReferencePicker",
  components: {
    NcCustomPickerElement: un,
    NcProviderList: Rn,
    NcRawLinkInput: Sn,
    NcSearch: jn
  },
  props: {
    /**
     * Provider to select on creation
     * Default: null. Show the provider list
     */
    initialProvider: {
      type: Object,
      default: () => null
    },
    /**
     * Optional width in pixels
     * Default: 100%
     */
    width: {
      type: Number,
      default: null
    },
    /**
     * Focus on the provider list select input on creation
     * Default: true
     */
    focusOnCreate: {
      type: Boolean,
      default: !0
    }
  },
  emits: [
    "cancel",
    "cancel-raw-link",
    "cancel-search",
    "provider-selected",
    "submit"
  ],
  data() {
    return {
      MODES: U,
      selectedProvider: this.initialProvider
    };
  },
  computed: {
    mode() {
      return this.selectedProvider === null ? U.providerList : z(this.selectedProvider.id) ? U.customElement : this.selectedProvider.search_providers_ids ? U.searchInput : U.standardLinkInput;
    },
    pickerWrapperStyle() {
      return {
        width: this.width ? this.width + "px" : void 0
      };
    }
  },
  mounted() {
    this.focusOnCreate && (this.initialProvider ? setTimeout(() => {
      this.$refs["url-input"]?.focus();
    }, 300) : this.$nextTick(() => {
      this.$refs["provider-list"]?.focus();
    }));
  },
  methods: {
    onEscapePressed() {
      this.selectedProvider !== null ? this.deselectProvider() : this.cancelProviderSelection();
    },
    onProviderSelected(t) {
      this.selectedProvider = t, this.$emit("provider-selected", t), this.$nextTick(() => {
        this.$refs["url-input"]?.focus();
      });
    },
    cancelCustomElement() {
      this.deselectProvider();
    },
    cancelSearch() {
      this.$emit("cancel-search", this.selectedProvider?.title), this.deselectProvider();
    },
    cancelRawLinkInput() {
      this.$emit("cancel-raw-link", this.selectedProvider?.title), this.deselectProvider();
    },
    cancelProviderSelection() {
      this.$emit("cancel");
    },
    submitLink(t) {
      this.selectedProvider !== null && pn(this.selectedProvider.id), this.$emit("submit", t), this.deselectProvider();
    },
    deselectProvider() {
      this.selectedProvider = null, this.$emit("provider-selected", null), setTimeout(() => {
        this.$refs["provider-list"]?.focus();
      }, 300);
    }
  }
};
var qn = function() {
  var e = this, r = e._self._c;
  return r("div", { staticClass: "reference-picker", style: e.pickerWrapperStyle, attrs: { tabindex: "-1" }, on: { keydown: function(n) {
    return !n.type.indexOf("key") && e._k(n.keyCode, "esc", 27, n.key, ["Esc", "Escape"]) ? null : (n.stopPropagation(), n.preventDefault(), e.onEscapePressed.apply(null, arguments));
  } } }, [e.mode === e.MODES.providerList ? r("NcProviderList", { ref: "provider-list", on: { "select-provider": e.onProviderSelected, submit: e.submitLink, cancel: e.cancelProviderSelection } }) : e.mode === e.MODES.standardLinkInput ? r("NcRawLinkInput", { ref: "url-input", attrs: { provider: e.selectedProvider }, on: { submit: e.submitLink, cancel: e.cancelRawLinkInput } }) : e.mode === e.MODES.searchInput ? r("NcSearch", { ref: "url-input", attrs: { provider: e.selectedProvider }, on: { cancel: e.cancelSearch, submit: e.submitLink } }) : e.mode === e.MODES.customElement ? r("div", { staticClass: "custom-element-wrapper" }, [r("NcCustomPickerElement", { attrs: { provider: e.selectedProvider }, on: { submit: e.submitLink, cancel: e.cancelCustomElement } })], 1) : e._e()], 1);
}, Mn = [], Un = /* @__PURE__ */ N(
  Bn,
  qn,
  Mn,
  !1,
  null,
  "12c38c93",
  null,
  null
);
const Dn = Un.exports;
F(It, At);
const zn = {
  name: "NcReferencePickerModal",
  components: {
    NcReferencePicker: Dn,
    NcModal: Wt,
    NcButton: Ft,
    ArrowLeftIcon: Gt,
    CloseIcon: Qt
  },
  props: {
    /**
     * Provider to select on creation
     * Show the provider list if no initial one is provided
     */
    initialProvider: {
      type: Object,
      default: () => null
    },
    /**
     * Focus on the input item on create
     */
    focusOnCreate: {
      type: Boolean,
      default: !0
    },
    /**
     * If true, add the modal content to the Viewer trap elements via the event-bus
     */
    isInsideViewer: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "cancel",
    "submit"
  ],
  data() {
    return {
      show: !0,
      selectedProvider: this.initialProvider,
      backButtonTitle: k("Back to provider selection"),
      closeButtonTitle: k("Close"),
      closeButtonLabel: k("Close Smart Picker")
    };
  },
  computed: {
    isProviderSelected() {
      return this.selectedProvider !== null;
    },
    showBackButton() {
      return this.initialProvider === null && this.isProviderSelected;
    },
    modalSize() {
      return this.isProviderSelected && z(this.selectedProvider.id) ? xt(this.selectedProvider.id) ?? "large" : "normal";
    },
    showModalName() {
      return !this.isProviderSelected || !z(this.selectedProvider.id);
    },
    modalName() {
      return this.isProviderSelected ? this.selectedProvider.title : k("Smart Picker");
    }
  },
  mounted() {
    if (this.isInsideViewer) {
      const t = this.$refs.modal_content;
      Ht("viewer:trapElements:changed", t);
    }
  },
  methods: {
    onCancel() {
      this.show = !1, this.$emit("cancel");
    },
    onSubmit(t) {
      this.show = !1, this.$emit("submit", t);
    },
    onProviderSelect(t) {
      this.selectedProvider = t, t === null && this.initialProvider !== null && this.onCancel();
    },
    onBackClicked() {
      this.$refs.referencePicker.deselectProvider();
    }
  }
};
var Fn = function() {
  var e = this, r = e._self._c;
  return e.show ? r("NcModal", { staticClass: "reference-picker-modal", attrs: { size: e.modalSize, "can-close": !1 }, on: { close: e.onCancel } }, [r("div", { ref: "modal_content", staticClass: "reference-picker-modal--content" }, [e.showBackButton ? r("NcButton", { staticClass: "back-button", attrs: { "aria-label": e.backButtonTitle, title: e.backButtonTitle }, on: { click: e.onBackClicked }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [r("ArrowLeftIcon")];
  }, proxy: !0 }], null, !1, 3001860362) }) : e._e(), r("NcButton", { staticClass: "close-button", attrs: { "aria-label": e.closeButtonLabel, title: e.closeButtonTitle, type: "tertiary" }, on: { click: e.onCancel }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [r("CloseIcon")];
  }, proxy: !0 }], null, !1, 2491825086) }), e.showModalName ? r("h2", [e._v(" " + e._s(e.modalName) + " ")]) : e._e(), r("NcReferencePicker", { ref: "referencePicker", attrs: { "initial-provider": e.initialProvider, "focus-on-create": e.focusOnCreate }, on: { "provider-selected": e.onProviderSelect, submit: e.onSubmit, cancel: e.onCancel } })], 1)]) : e._e();
}, Wn = [], Hn = /* @__PURE__ */ N(
  zn,
  Fn,
  Wn,
  !1,
  null,
  "ab09ebaa",
  null,
  null
);
const Gn = Hn.exports;
async function gi(t = null, e = void 0) {
  return await new Promise((r, n) => {
    const i = "referencePickerModal", s = document.createElement("div");
    s.id = i, document.body.append(s);
    const o = t === null ? null : ln(t) ?? null, a = Kt.extend(Gn), c = new a({
      propsData: {
        initialProvider: o,
        isInsideViewer: e
      }
    }).$mount(s);
    c.$on("cancel", () => {
      c.$destroy(), n(new Error("User cancellation"));
    }), c.$on("submit", (u) => {
      c.$destroy(), r(u);
    });
  });
}
export {
  st as L,
  nn as N,
  vi as U,
  _t as a,
  ln as b,
  wt as c,
  hn as d,
  Dn as e,
  Gn as f,
  gi as g,
  jn as h,
  Xr as i,
  Jr as p,
  mi as r,
  fn as s
};
